<div class="content-block">
  <div class="d-flex align-items-center" style="justify-content: space-between">
    <h2 style="margin-right: 1rem">
      {{ formatMessage("publisherConfiguration.title") }}
    </h2>
  </div>

  <div
    class="d-flex align-items-center"
    style="margin-bottom: calc(1em - 10px)"
  >
    <!-- Publisher Selection -->
    <div style="margin-right: 0.5rem">
      {{ formatMessage("publisherConfiguration.selectPublisher") }}
    </div>
    <div>
      <!-- Publisher SelectBox -->
      <dx-select-box
        *ngIf="!loading && !loadError"
        [dataSource]="publishers"
        displayExpr="displayName"
        valueExpr="id"
        [placeholder]="
          formatMessage('publisherConfiguration.selectPublisher.placeholder')
        "
        [(value)]="selectedPublisher"
        (onValueChanged)="onPublisherSelectionChanged($event)"
        [showClearButton]="true"
        [disabled]="publishers.length === 0"
        style="min-width: 200px"
      ></dx-select-box>

      <!-- No Publishers Available -->
      <div
        *ngIf="!loading && !loadError && publishers.length === 0"
        class="no-data-container"
        style="margin: 10px 0"
      >
        <div class="alert alert-info">
          <i class="fas fa-info-circle" style="margin-right: 8px"></i>
          {{ formatMessage("publisherConfiguration.noPublishersAvailable") }}
        </div>
      </div>
      <!-- Loading State -->
      <div *ngIf="loading" class="loading-container" style="margin: 10px 0">
        <i class="fas fa-spinner fa-spin"></i>
        {{ formatMessage("publisherConfiguration.loadingPublishers") }}
      </div>

      <!-- Error State -->
      <div
        *ngIf="loadError && !loading"
        class="error-container"
        style="margin: 10px 0"
      >
        <div class="alert alert-danger d-flex align-items-center">
          <i class="fas fa-exclamation-triangle" style="margin-right: 8px"></i>
          <span>{{
            formatMessage("publisherConfiguration.loadPublishersError")
          }}</span>
          <button
            type="button"
            class="btn btn-sm btn-outline-danger ms-auto"
            (click)="retryLoadPublishers()"
          >
            {{ formatMessage("publisherConfiguration.retry") }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div>
    <!-- Kachel Container - Similar to Produktdetails -->
    <div
      *ngIf="selectedPublisher; else noPublisherSelected"
      class="d-flex kachel-container"
    >
      <app-kachel class="flex-grow properties-kachel">
        <app-component-pricelist
          [publisherId]="selectedPublisher"
          (reloadEvent)="reloadComponentPriceData($event)"
          class="d-flex flex-grow flex-column kachel-component"
        >
        </app-component-pricelist>
      </app-kachel>
      <!-- Future: Additional Kacheln can be added here -->
      <!--
      <app-kachel class="flex-grow properties-kachel">
        <app-publisher-settings
          [publisherId]="selectedPublisher"
          class="d-flex flex-grow flex-column kachel-component">
        </app-publisher-settings>
      </app-kachel>
      -->
    </div>
    <ng-template #noPublisherSelected>
      <div class="d-flex kachel-container">
        <app-kachel
          [cssStyles]="'backgroundColor: #f2f2f2; justify-content: center'"
          class="
            flex-grow
            properties-kachel
            d-flex
            align-items-center
            justify-content-center
          "
          style="min-height: 200px"
        >
          <div
            class="alert alert-info text-center w-100"
            style="color: #8e8e8e"
          >
            {{ formatMessage("publisherConfiguration.noPublisherSelected") }}
          </div>
        </app-kachel>
      </div>
    </ng-template>
  </div>
</div>
